import { useImperativeHandle, useState } from 'react';
import {
    AdvancedMarker,
    InfoWindow,
    useAdvancedMarkerRef
} from '@vis.gl/react-google-maps';
import { Coords } from '../utils/types';

export interface AddressMarkerRef {
    setPosition: (coords?: Coords) => void;
    setInfoText: (text?: string) => void;
}

interface AddressMarkerProps {
    ref?: React.Ref<AddressMarkerRef>
}

export const AddressMarker = (props: AddressMarkerProps) => {
    const [infowindowOpen, setInfowindowOpen] = useState(false);
    const [markerRef, marker] = useAdvancedMarkerRef();
    const [position, setPosition] = useState<google.maps.LatLngLiteral>();
    const [infoText, setInfoText] = useState<string>();

    useImperativeHandle(props.ref, () => {
        return {
            setPosition(coords) {
                setPosition(coords ? { lat: coords.latitude, lng: coords.longitude } : undefined)
            },
            setInfoText,
        };
    }, []);


    return (
        <>
            <AdvancedMarker
                ref={markerRef}
                onClick={() => setInfowindowOpen(prev => !prev)}
                position={position}
                title={'Address Marker'}
            />
            {infowindowOpen && (
                <InfoWindow
                    className='z-20'
                    anchor={marker}
                    maxWidth={200}
                    headerDisabled
                    onCloseClick={() => setInfowindowOpen(false)}>
                    <span className="font-medium">{infoText}</span>
                </InfoWindow>
            )}
        </>
    );
};